<template>

    <Head>
        <title>A1 Seviye İngilizce Kelimeler A-Z | PDF + Quiz + Telaffuzlar + Örnek Cümle</title>
        <meta name="title" content="A1 Seviye İngilizce Kelimeler A-Z | PDF + Quiz + Telaffuzlar + Örnek Cümle" />
        <meta name="description"
            content="A1 seviye İngilizce kelimeleri buradan Quiz ile öğrenebilirsiniz. 1000 kelimelik listenin telaffuzu, örnek cümle içinde kullanımı ve PDF dosyası eklendi." />
        <link rel=”canonical” href="https://diziyleogren.com/blog/a1-seviye-ingilizce-kelimeler-ve-anlamlari" />
        <meta property="og:title"
            content="A1 Seviye İngilizce Kelimeler A-Z | PDF + Quiz + Telaffuzlar + Örnek Cümle" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://diziyleogren.com/blog/a1-seviye-ingilizce-kelimeler-ve-anlamlari" />
        <meta property="og:description"
            content="A1 seviye İngilizce kelimeleri buradan Quiz ile öğrenebilirsiniz. 1000 kelimelik listenin telaffuzu, örnek cümle içinde kullanımı ve PDF dosyası eklendi." />
        <meta property="og:site_name" content="Diziyle Öğren" />
        <meta property="article:published_time" content="2024-05-01T15:02:41+03:00" />
        <meta property="article:modified_time" content="2025-01-04T19:07:32+03:00" />
    </Head>
    <div class="container pt-5 mt-3 mb-5">

        <div class="row mx-auto">
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
            <div class="col-12 col-md-8 mx-auto">

                <h1 class="archivo">A1 Seviye İngilizce Kelimeler A-Z | PDF + Quiz + Telaffuzlar + Örnek Cümle</h1>
                <p class="mt-5">Merhaba bu blog yazımızda <b>A1 zorluk seviyesindeki İngilizce kelimeleri </b> sizlerle
                    paylaşıyoruz.
                    Bu
                    kelimeleri öğrenmek İngilizce okuma, dinleme, yazma hatta konuşma yeteneklerinize olumlu etki
                    edecektir. Bu kelimeler <b>İngilizce’de en çok kullanılan kelimeler</b> olduğu için bu kelimeleri
                    öğrenerek temel anlamda birçok İngilizce cümleyi anlayabilir hale gelebilirsiniz.</p>

                <h2 class="archivo">A1 Seviye İngilizce Kelimeleri Nasıl Öğrenebilirim? </h2>
                <br>
                <p>Aşağıdaki listede her bir kelimeyi kelimenin anlamıyla birlikte listeledik. <b>Listemiz
                        1000
                        kelimeden oluşmaktadır. </b>Listedeki kelimelerin 1 den 9'a kadar zorluk seviyesini de
                    belirledik.
                    Zorluk
                    barını kullanarak kelimeleri zorluğuna göre filtreleyebilirsiniz. Kelimelerin yanındaki ses
                    işaretine tıklayarak <b>her bir kelimenin telaffuzunu
                        dinleyebilirsiniz.</b> Ayrıca kelimelerin üstüne tıklayarak <b>kelimelerin örnek cümle içinde
                        kullanımını</b> görebilirsiniz.
                    Göz simgesine tıklayarak <b>bildiğiniz kelimeleri listeden
                        çıkarmanız</b> da
                    mümkün. Listeden çıkarma işlemini tamamladıktan sonra Quiz’e Git butonu ile Kelime Quiz’ini
                    başlatabilirsiniz. <b>Quiz sekmesinde kelimeleri öğrenebilmeniz için 8 farklı oyun modu ekledik.</b>
                    İstediğiniz modları seçerek karışık modda kelimeleri öğrenebilirsiniz.</p>

                <h2 class="archivo">Bu Kelime Listesi Nasıl Oluşturuldu? </h2>
                <br>
                <p>Diziyle Öğren olarak geliştirdiğimiz küçük çaplı bir yapay zeka 50’den fazla İngilizce dizi ve filmi
                    taradı ve sizler
                    için en çok kullanılan A1 seviyesindeki kelimeleri belirledi. <b>Aşağıdaki liste A1 seviyesindeki
                        İngilizce
                        kelimelerden oluşmaktadır.</b> Daha fazla dizi ve film taradıkça listemiz <b>otomatik olarak
                        güncellenmektedir.</b> Yakın zamanda daha zor kelime listeleri için de blog yazımızı
                    paylaşacağız. Blog
                    yazısı yayınlandığında haberdar olmak için bizi <a href="https://www.instagram.com/diziyleogren/"
                        target="_blank">sosyal medya</a> hesaplarımızdan takip edebilirsiniz.
                </p>

                <h2 class="archivo">İngilizce A1 Kelime Listesi PDF </h2>
                <br>
                <p> <b>Kelimeleri çıktı alıp çalışmak istiyorsanız
                        PDF
                        dosyasını aşağıdan indirebilirsiniz.</b>
                    PDF dosyasına sadece Premium üyelerimiz erişebilir. Sınırsız PDF indirme avantajının yanında Premium
                    üyelik ile dizilerde kullanılan kelimelere ve özel içeriklere de erişebilirsiniz. Sizler için bu
                    tür özel listeler hazırlamaya devam edeceğiz 😊</p>

                <div class="primary-container">
                    <h3 class="title">İngilizce A1 Kelime Listesi.pdf</h3>
                    <router-link v-if="isPremium" to="/premium/ingilizce-a1-kelime-listesi-pdf">
                        <button class="download-button" data="İNDİR">İNDİR</button>
                    </router-link>
                    <template v-else>
                        <router-link :to="{ path: $store.getters.getLocaleLink('/premium') }"
                            class="text-decoration-none">
                            <button class="upgrade-button" data="Yükselt">PREMİUM</button>
                        </router-link>
                        <small>Sınırsız PDF indirme hakkı ve Premium üyelik sadece 59.99 TL!
                        </small>
                    </template>

                </div>

                <div v-if="false" class="ad-container-yatay">
                    <Adsense data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990" data-ad-format="auto"
                        :data-full-width-responsive="true">
                    </Adsense>
                </div>
                <br>
                <h2 class="archivo mt-4"> A1 İngilizce Kelime Listesi </h2>
                <p class="mt-4">Kelime listesini Quiz ile aşağıdan ücretsiz bir şekilde çalışabilirsiniz. Umarız
                    İngilizce Öğrenme
                    sürecinizde sizlere
                    faydalı olabiliriz. Şimdiden
                    keyifli
                    çalışmalar dileriz 😊</p>
                <div class="row mt-5">
                    <WordListComponent v-if="isReady" :wordList="wordListData.words" :sliderValueArg="[1, 9]">
                    </WordListComponent>
                    <Loading style="" v-else />
                </div>
                <SuggestedBlogs></SuggestedBlogs>
                <div class="row">
                    <div itemscope="" itemtype="http://schema.org/CreativeWork">
                        <meta itemprop="dateModified" content="2025-01-01">
                    </div>
                </div>
            </div>
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import WordListComponent from "../../../components/Shared/WordListComponent.vue";
import SuggestedBlogs from "../../../components/Shared/SuggestedBlogs.vue";

export default {
    data() {
        return {
            wordListData: {},
            isReady: false
        };
    },
    components: {
        WordListComponent,
        SuggestedBlogs
    },

    created() {
        this.$store.commit('setEditOption', false)

        axios.get('/api/WordList/GetPublicList', { params: { uniqueKey: "ilk1000" } }).then((response) => {
            this.wordListData = JSON.parse(JSON.stringify(response.data))

        }).finally(() => {
            this.isReady = true
        }).catch(error => {
            console.log(error.response.data)
        })
    },
    computed: {
        isPremium() {
            return this.$store.getters.getUserData.isPremium
        }
    }
}

</script>
<style scoped>
.primary-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
    border-radius: 16px;
    background-color: #FBFBFB;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);
    padding: 16px;
    width: 95%;
    max-width: 960px;
}

.title {
    color: var(--Primary, #8887C6);
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.upgrade-button {
    width: 144px;
    height: 48px;
    background-color: #B26C6C;
    transition: background-color 0.5s;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.download-button {
    width: 144px;
    height: 48px;
    color: var(--Lightest-Gray, #FBFBFB);
    background-color: var(--Green---Success, #9CD189);
    transition: background-color 0.5s;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.upgrade-button:hover {
    background-color: #b36060;
}

.download-button:hover {
    background-color: #83c969;
}
</style>